import {
  SET_PENDING_DRIVERS,
  SET_APPROVED_DRIVERS,
  PENDING_DRIVERS_LOADING,
  PENDING_DRIVERS_STOP_LOADING,
} from "../../types";

const INITIAL_STATE = {
  pending: [],
  approved: [],
  loading: false,
};

export default function drivers(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_PENDING_DRIVERS:
      return {
        ...state,
        pending: action.pending,
      };
    case PENDING_DRIVERS_LOADING:
      return {
        ...state,
        loading: true,
      };
    case PENDING_DRIVERS_STOP_LOADING:
      return {
        ...state,
        loading: false,
      };
    case SET_APPROVED_DRIVERS:
      return {
        ...state,
        approved: action.approved,
      };
    default:
      return state;
  }
}
